/** Namespace `bankTransfer` — bản gốc tiếng Việt. Khoá phẳng, tên camelCase; `{biến}` để chèn. */
export const bankTransfer = {
  title: "Xác nhận chuyển khoản",
  "intro.pre": "Dùng khi thấy tiền về tài khoản của Bube. Nội dung chuyển khoản ",
  "intro.strong1": "chính là",
  "intro.mid": " mã thu tiền. Xác nhận sẽ cấp gói cho cửa hàng và phát hoá đơn điện tử — ",
  "intro.strong2": "không rút lại được",
  "intro.post": ".",
  codeLabel: "Mã thu tiền",
  codePlaceholder: "vd. Ab3xK9mQ2p",
  lookingUp: "Đang tra…",
  lookup: "Tra cứu",
  lookupFailed: "Không tra cứu được mã thu tiền.",
  confirmFailed: "Không xác nhận được.",
  "result.confirmed": "Đã xác nhận. Gói được áp.",
  "result.confirmedWithLots": "Đã xác nhận. Gói được áp, và {count} lô extra được bật.",
  "result.alreadyConfirmed": "Lượt thu này đã được xác nhận từ trước — lần bấm này không cấp thêm gì, và đó là đúng.",
  "result.shortfall": " Ghi nhận thu THIẾU {amount}.",
  "result.overpaid": " Khách chuyển THỪA {amount}.",
  workspace: "Cửa hàng",
  workspaceDeleted: "(workspace đã bị xoá)",
  plan: "Gói",
  months: "{months} tháng",
  amountDue: "Phải thu",
  period: "Kỳ",
  "already.pre": "Lượt thu này ",
  "already.strong": "đã được xác nhận",
  "already.post": ". Không có gì để làm thêm.",
  "paypal.pre": "Đây là lượt thu qua ",
  "paypal.post":
    ", không phải chuyển khoản. Đường đó tự xác nhận lúc capture — xác nhận tay ở đây sẽ cấp gói mà bỏ qua bước thu tiền.",
  paidLabel: "Số tiền THẬT SỰ về (đọc trên sao kê)",
  "short.pre": "Khách chuyển ",
  "short.strong": "thiếu {amount}",
  "short.post": ". Tôi biết và vẫn cấp gói. Khoản thiếu được ghi lại ở bube-shop.",
  overpaid: "Khách chuyển thừa {amount} — vẫn cấp được.",
  confirming: "Đang xác nhận…",
  confirm: "Xác nhận đã nhận tiền",
  tickShortfall: "Tích ô xác nhận thu thiếu để bật nút.",
} as const;
